// extracted by mini-css-extract-plugin
module.exports = {"Page":"Price_Page__39l74","StickyButtons":"Price_StickyButtons__27a0F","ButtonWrap":"Price_ButtonWrap__2xe91","StickyButtonsExtranet":"Price_StickyButtonsExtranet__1JhcV"};